import React, { createContext, useState, useContext, useEffect } from 'react';
import { storage } from '../utils/storage';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = storage.get('user');
    if (savedUser) {
      setUser(savedUser);
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    const userWithTimestamp = {
      ...userData,
      joinedAt: new Date().toISOString()
    };
    setUser(userWithTimestamp);
    storage.set('user', userWithTimestamp);
  };

  const logout = () => {
    setUser(null);
    storage.remove('user');
    storage.remove('moodData');
    storage.remove('pomodoroSessions');
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};